import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

export default function Edit() {
	const blockProps = useBlockProps( {
		className: 'brandy-sticky-section',
	} );
	const innerBlocksProps = useInnerBlocksProps(
		{ className: 'brandy-sticky-section__inner' },
		{}
	);

	return (
		<div { ...blockProps }>
			<div { ...innerBlocksProps } />
		</div>
	);
}
